import React from "react";

/**
 * ErrorBoundary global.
 * Captura crashes de render de cualquier ruta y muestra fallback amigable
 * con botón para recargar. En producción esto evita las páginas en blanco.
 * Además maneja ChunkLoadError (deploy con bundles nuevos): auto-recarga.
 */
export default class ErrorBoundary extends React.Component {
  state = { hasError: false, err: null };

  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }

  componentDidCatch(err, info) {
    console.error("ErrorBoundary caught:", err, info);
    // Auto-reload en ChunkLoadError (bundle stale post-deploy)
    if (err && (err.name === "ChunkLoadError" || /Loading chunk .* failed/i.test(String(err.message)))) {
      // Evitar loops: solo recargar una vez por sesión
      if (!sessionStorage.getItem("__chunk_reload__")) {
        sessionStorage.setItem("__chunk_reload__", "1");
        window.location.reload();
      }
    }
  }

  handleReload = () => {
    sessionStorage.removeItem("__chunk_reload__");
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#F9F9F8] grid place-items-center px-6">
          <div className="max-w-md text-center bg-white border border-zinc-200 rounded-sm p-8">
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 grid place-items-center mb-4">
              <span className="text-3xl">⚠️</span>
            </div>
            <h1 className="font-display font-black text-2xl tracking-tighter">Ups, algo salió mal</h1>
            <p className="mt-2 text-sm text-zinc-600">
              La página no pudo cargar. Puede ser una actualización reciente. Recarga para intentar de nuevo.
            </p>
            <button
              data-testid="eb-reload"
              onClick={this.handleReload}
              className="mt-6 px-6 h-11 rounded-sm bg-[#FF3366] hover:bg-[#E62958] text-white font-medium"
            >
              Recargar página
            </button>
            {this.state.err?.message && (
              <details className="mt-4 text-xs text-zinc-400 text-left">
                <summary className="cursor-pointer">Detalles técnicos</summary>
                <pre className="mt-2 whitespace-pre-wrap break-words">{String(this.state.err.message)}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
